const DEFAULT_GTM_URL = 'https://www.googletagmanager.com/gtm.js';

export const createScriptTag = (
    win: typeof window,
    containerId: string,
    gtmBaseUrl: string = DEFAULT_GTM_URL,
) => {
    const script = win.document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('defer', '');
    script.classList.add('protected');
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    '${gtmBaseUrl}?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${containerId}');`;
    return script;
};
